// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackCancelOrderParameters extends TrackEventBaseParameters {}

const trackCancelOrder = (parameters: TrackCancelOrderParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "cancel_order", ...parameters }, options);
};

export default trackCancelOrder;
